import React from 'react';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import columns from './columns';
import useAuthContext from '../../contexts/AuthContext';

const ListContracts = () => {
  const { user } = useAuthContext();

  return (
    <SimpleResourceLandingLayout
      withCreateButton={false}
      resourceName="contracts"
      extraQuery={`status!=QUOTE&!previous_contract${
        user?.permissionManagement?.contracts ? '' : `&user=${user?._id}`
      }&fields=-children`}
      populate="insurer"
      columns={columns()}
      editAction={false}
      deleteAction={false}
      scroll={{ x: 1000 }}
    />
  );
};

export default ListContracts;
